var _rect, _rect2, _path, _circle, _path2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdsQuiz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#172554"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 120,
    width: 628,
    height: 300,
    rx: 24,
    fill: "#1e3a8a",
    stroke: "#93c5fd",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145 190h510M145 255h510M145 320h300",
    stroke: "#60a5fa",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 350,
    r: 48,
    fill: "#22c55e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m584 350 18 18 35-40",
    fill: "none",
    stroke: "#052e16",
    strokeWidth: 12
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#bfdbfe",
    fontFamily: "sans-serif",
    fontSize: 40,
    fontWeight: 700
  }, "CDS QUIZ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 475,
    fill: "#93c5fd",
    fontFamily: "monospace",
    fontSize: 22
  }, "PRACTICE \u2022 TRACK \u2022 IMPROVE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdsQuiz);
export default __webpack_public_path__ + "static/media/cds-quiz.7915e5f06ff3d451643d2d0eda87d3c4.svg";
export { ForwardRef as ReactComponent };